

















import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
@Component
export default class AboutMe extends Vue
{
    private aboutText: string[] = [
      "My name is Randall. I currently work as a senior software " +
      "engineer for WAE and work with a team that makes " +
      "tools for our helping place workers in jobs. On that team we " +
      "work with microservices, javascript, mongo, and React.",
      "I've done work with freelance projects, created packages, and more! " +
      "Engineering systems is my passion. I read books and articles, listen to " +
      "podcasts, and actively seek courses that all better my knowledge and skills.",
      "Personally, I love to read. Roleplaying games take up my Sundays. "+
      "I've been to almost every brewery in my area of Charlotte, NC. " +
      "My hands seek to stay busy, so I've tried and enjoy a plethora of hobbies. "+
      "I spend the majority of my time, though, with my wife and son."
    ];
    @Getter("IsItDark") private getterIsDark!: boolean;
}
